export const namespaced = true;

export const state = {
  activeTab: "",
};

export const getters = {
  activeTab: (state) => {
    return state.activeTab;
  },
};

export const mutations = {
  SET_ACTIVE_TAB(state, activeTab) {
    state.activeTab = activeTab;
  },
  CLEAR_ACTIVE_TAB(state) {
    state.activeTab = "MyOrder";
  },
};

export const actions = {
  setActiveTab({ commit }, activeTab) {
    commit("SET_ACTIVE_TAB", activeTab);
  },
  clearData({ commit }) {
    commit("CLEAR_ACTIVE_TAB");
  },
};
